import { ChangeDetectionStrategy, Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { AurToastStackComponent } from '@shared/ui/aur/aur-toast-stack/aur-toast-stack.component';
import { ToastHostComponent } from '@shared/ui/toast-host/toast-host.component';
import { TruncationTooltipComponent } from '@shared/ui/truncation-tooltip/truncation-tooltip.component';

/**
 * Root shell: router + app notifications + gallery toast stack + the
 * tooltip that shows truncated table text in full.
 * Callers: main.ts bootstrap. Affected API: ToastService stack for widget-book.
 * User: please add it also
 */
@Component({
  selector: 'app-root',
  imports: [RouterOutlet, ToastHostComponent, AurToastStackComponent, TruncationTooltipComponent],
  template: `
    <router-outlet />
    <app-toast-host />
    <aur-toast-stack />
    <app-truncation-tooltip />
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class App {}
